import React from 'react'

import { AgentPageProps } from '../AgentPage'

import MobileFooter from '../../organisms/MobileFooter'

import { useBreakpoint } from '../../../providers/BreakpointProvider'
import useStyles from './styles'

type MobileAgentPageProps = Omit<
  AgentPageProps,
  'statsComponent' | 'scroll' | 'centerContent' | 'disablePadding'
>

const MobileAgentPage: React.FC<MobileAgentPageProps> = ({
  rootRef,
  hideMobileFooter,
  children
}) => {
  const { isSmall } = useBreakpoint()

  const classes = useStyles({ smallMedia: isSmall, hideMobileFooter })

  return (
    <>
      <div ref={rootRef} id='agentPage' className={classes.root}>
        <div className={classes.children}>{children}</div>
      </div>

      {isSmall && !hideMobileFooter && <MobileFooter />}
    </>
  )
}

export default MobileAgentPage
